export const getItemRequestsForApproval = (state) =>
  state.itemRequestsForApproval.results;


export const getItemRequestsForApprovalCount = (state) =>
  state.itemRequestsForApproval.count;


